<template>
  <div>
    <page-header
      left-side-class="col-12 col-md-7"
      :page="headerConfig"
      right-side-class="col-12 col-md-5"
      class="mt-3 mt-md-0"
      @onReturn="() => $router.back()"
      :has-return="true"
    />

    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import AcademicYearServices from '@/services/api/academicyear.api'
import codeAcademicYear from '@/utils/constants/codeAcademicYear.js'
import ReportServices from '@/modules/report/api'
import DocumentServices from '@//modules/report/document'
export default {
  name: 'BilledEvaluations',
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => ({
    model: {
      search: {
        filters: {
          studentSieId: null,
          evaluationDate: null,
          academicYear: null,
        },
        collections: {
          academicYears: [],
        },
      },
    },
  }),
  computed: {
    headerConfig() {
      return {
        title: 'Informe de las Evaluaciones en el expediente del Estudiantes',
        icon:
          'fa-solid fa-magnifying-glass-chart pr-0 font-22 magnifying-glass-icon-m ',
        routes: [
          'Inicio',
          'Informe de las Evaluaciones en el expediente del Estudiante',
        ],
      }
    },
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Año Académico',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar un año académico.',
          validations: 'required',
          class: 'col-md-3',
          clearable: false,
          options: this.model.search.collections.academicYears,
          value: this.model.search.filters.academicYear,
          onChanged: this.onChangeAcademicYear,
        },
        {
          name: 'studentSieId',
          label: 'SIE:',
          component: 'CustomInput',
          class: 'col-12 col-md-3',
          value: this.model.search.filters.studentSieId,
          placeholder: 'Escriba número de SIE',
          type: 'text',
        },
        {
          name: 'evaluationDate',
          label: 'Fecha de Evaluación:',
          component: 'custom-date-picker',
          class: 'col-12 col-md-3',
          value: this.model.search.filters.requestNumber,
          placeholder: 'Escriba la Fecha de Evaluación',
          classContainer: 'date-width-container',
          maxDate: new Date(),
        },
      ]
    },
  },
  async mounted() {
    await this.getInitialFilters()
  },
  methods: {
    async onHandlerSearch() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate()
      if (isValid) {
        this.process()
      }
    },
    async getInitialFilters() {
      this.model.search.collections.academicYears = (
        await AcademicYearServices.getAcademicYearsFromSpecificYear(
          codeAcademicYear['2016-2017']
        )
      ).data
    },
    async onChangeAcademicYear() {
      await this.getCenters()
    },
    async process() {
      await ReportServices.getReport('allstudentevaluations', {
        academicYearId: this.model.search.filters.academicYear?.id,
        studentSieId: this.model.search.filters.studentSieId,
        evaluationDate: this.model.search.filters.evaluationDate,
      }).then((res) => DocumentServices.Download(res.data))
    },
  },
}
</script>

<style lang="scss" scoped></style>
